import React from "react";
import { Typography } from "antd";
import { LockOutlined, PhoneOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import { getSuspension, getSuspensionMessage } from "../Services/suspension";

// Bandeau d'avertissement affiché quand le compte est suspendu
const SuspensionBanner = ({ style }) => {
  const suspension = getSuspension();
  const { isSuspendu, motif, description, origine } = suspension;
  if (!isSuspendu) return null;

  const titre = getSuspensionMessage(suspension);
  // Le motif est déjà dans la phrase du participant : pastille seulement pour l'adhérent
  const showMotifTag = origine === "adherent" && motif;

  return (
    <div
      role="alert"
      style={{
        position: "relative",
        display: "flex",
        alignItems: "center",
        gap: 16,
        padding: "14px 18px",
        borderRadius: 16,
        background: "linear-gradient(120deg, #fff1f0 0%, #fff7e6 100%)",
        border: "1px solid #ffccc7",
        boxShadow: "0 10px 30px rgba(245, 34, 45, 0.12)",
        overflow: "hidden",
        animation: "ipm-banner-in 0.6s cubic-bezier(0.22, 1, 0.36, 1)",
        ...style,
      }}
    >
      <style>{`
        @keyframes ipm-banner-in { from { opacity: 0; transform: translateY(-8px) } to { opacity: 1; transform: none } }
        @keyframes ipm-ring { 0% { box-shadow: 0 0 0 0 rgba(245,34,45,0.45) } 70% { box-shadow: 0 0 0 12px rgba(245,34,45,0) } 100% { box-shadow: 0 0 0 0 rgba(245,34,45,0) } }
      `}</style>

      {/* Liseré latéral */}
      <span
        style={{
          position: "absolute",
          left: 0,
          top: 0,
          bottom: 0,
          width: 5,
          background: "linear-gradient(180deg, #ff7875, #f5222d)",
        }}
      />

      <span
        style={{
          flexShrink: 0,
          width: 46,
          height: 46,
          borderRadius: "50%",
          background: "linear-gradient(135deg, #ff7875, #f5222d)",
          color: "#fff",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: 20,
          animation: "ipm-ring 2s infinite",
        }}
      >
        <LockOutlined />
      </span>

      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap" }}>
          <Typography.Text style={{ fontWeight: 700, fontSize: 15, color: "#a8071a" }}>
            {titre}
          </Typography.Text>
          {showMotifTag && (
            <span
              style={{
                padding: "1px 10px",
                borderRadius: 999,
                fontSize: 12,
                fontWeight: 600,
                color: "#cf1322",
                background: "#ffffffb3",
                border: "1px solid #ffa39e",
              }}
            >
              Motif : {motif}
            </span>
          )}
        </div>
        <Typography.Text style={{ display: "block", fontSize: 13, color: "#5c0011", marginTop: 2 }}>
          {description ||
            "La création de nouveaux documents est temporairement indisponible."}
        </Typography.Text>
      </div>

      <Link
        to="/contact"
        style={{
          flexShrink: 0,
          display: "inline-flex",
          alignItems: "center",
          gap: 6,
          padding: "6px 14px",
          borderRadius: 999,
          fontSize: 13,
          fontWeight: 600,
          color: "#fff",
          background: "linear-gradient(135deg, #ff4d4f, #cf1322)",
          boxShadow: "0 6px 16px rgba(207, 19, 34, 0.3)",
          whiteSpace: "nowrap",
        }}
      >
        <PhoneOutlined /> Nous contacter
      </Link>
    </div>
  );
};

export default SuspensionBanner;
